function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icomoon-ignore"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 4,
  strokeWidth: 34.1333,
  stroke: "#000",
  d: "M256 415.289c87.973 0 159.289-71.316 159.289-159.289s-71.316-159.289-159.289-159.289c-87.973 0-159.289 71.316-159.289 159.289s71.316 159.289 159.289 159.289z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 4,
  strokeWidth: 34.1333,
  stroke: "#000",
  d: "M256 28.445v136.534"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 4,
  strokeWidth: 34.1333,
  stroke: "#000",
  d: "M256 347.022v136.534"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 4,
  strokeWidth: 34.1333,
  stroke: "#000",
  d: "M28.445 256h136.534"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 4,
  strokeWidth: 34.1333,
  stroke: "#000",
  d: "M347.022 256h136.534"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinejoin: "miter",
  strokeLinecap: "square",
  strokeMiterlimit: 4,
  strokeWidth: 34.1333,
  stroke: "#000",
  d: "M284.445 256c0 15.709-12.735 28.445-28.445 28.445s-28.445-12.735-28.445-28.445c0-15.709 12.735-28.445 28.445-28.445s28.445 12.735 28.445 28.445z"
});

var SvgTarget = function SvgTarget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTarget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/target.517df833.svg";
export { ForwardRef as ReactComponent };